export const PARAM_TOKEN = 'token';
export const PARAM_IN_PAGE = 'inPage';
export const REGION = {
    EN: {
        ALL: 'all',
        NORTH: 'north',
        CENTRAL: 'central',
        SOUTH: 'south',
    },
    VI: {
        ALL: 'all',
        NORTH: 'bac',
        CENTRAL: 'trung',
        SOUTH: 'nam',
    },
};
